import { render, staticRenderFns } from "./ProductPagination.vue?vue&type=template&id=3ad797a7&"
import script from "./ProductPagination.vue?vue&type=script&lang=js&"
export * from "./ProductPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports